import { isIndiaClient } from './client';

/** Trim only — no length or country rules (international WhatsApp numbers). */
export const normalizeOptionalWhatsapp = (value) => String(value ?? '').trim();

export const productsRequiredForStore = (adminData) => !isIndiaClient(adminData);
